import { School } from "../types/School";
import api from "./api";

export const getSchools = async () => {
  try {
    const response = await api.get("/schools");
    return response.data;
  } catch (error) {
    console.error("Failed to fetch schools", error);
    throw error;
  }
};

export const createSchool = async (schoolData: School) => {
  try {
    const response = await api.post("schools", schoolData, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error creating school:", error);

    throw error;
  }
};

export const updateSchool = async (schoolId: string, updatedData: School) => {
  try {
    const response = await api.put(`schools/${schoolId}`, updatedData);
    return response.data;
  } catch (error) {
    console.error("Error updating school:", error);
    throw error;
  }
};

export const deleteSchool = async (schoolId: string) => {
  try {
    const response = await api.delete(`schools/${schoolId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting school:", error);
    throw error;
  }
};
